<canvas #canvas class="w-full h-full"></canvas>